import LegalShell from "./LegalShell";
import { useLang } from "../../i18n";

const EMAIL = "info@shakeandshake.com";

const renderText = (text) => {
  if (!text.includes(EMAIL)) return text;
  const idx = text.indexOf(EMAIL);
  return (
    <>
      {text.slice(0, idx)}
      <a href={`mailto:${EMAIL}`} className="text-[#9B7AE8] underline underline-offset-4">
        {EMAIL}
      </a>
      {text.slice(idx + EMAIL.length)}
    </>
  );
};

export default function Kvkk() {
  const { t } = useLang();
  const k = t.kvkk;
  return (
    <LegalShell title={k.title} testid="kvkk-page">
      <p className="mb-2 text-sm font-medium text-[#8E85AC]" data-testid="kvkk-updated">
        {k.updated}
      </p>
      <div className="mt-8">
        {k.blocks.map((b, i) => (
          <section key={i} className="border-b border-[#9B7AE8]/12 py-8 first:pt-0 last:border-0" data-testid={`kvkk-block-${i}`}>
            <h2 className="font-display mb-4 text-lg font-bold text-[#221A3D]">{b.title}</h2>
            <div className="space-y-1.5 text-base leading-relaxed text-[#5F5780]">
              {b.paras && b.paras.map((p, j) => <p key={j}>{renderText(p)}</p>)}
              {b.list && (
                <ul>
                  {b.list.map((item, j) => (
                    <li key={j} className="border-b border-[#9B7AE8]/10 py-3 last:border-0">
                      {renderText(item)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>
    </LegalShell>
  );
}
